<input type="file" id="actual-btn" @change="onFileSelected($event)" :accept="accept" hidden />
<label for="actual-btn" :class="file__uploaded + has__border">
    <span>
        <i class="material-icons icon" :class="show">{{!file__uploaded ? icon : 'check'}}
        </i>
    </span>{{!file__uploaded ? label : uploadedLabel}}
</label>